'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _antd = require('@adparlor-devops/antd');

var _immutabilityHelper = require('immutability-helper');

var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);

var _reactRouter = require('react-router');

var _components = require('../../../components');

var _selectors = require('../../../store/blueprint/selectors');

var _generic = require('../../../helpers/generic');

require('./LayerCreator.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LayerCreator = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(LayerCreator, _Component);

  function LayerCreator() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, LayerCreator);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = LayerCreator.__proto__ || (0, _getPrototypeOf2.default)(LayerCreator)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      layerCount: 1,
      layerTemplates: [{
        id: 1,
        title: 'Layer 1',
        enableTitleEdit: false,
        contentType: null
      }],
      blueprintPreLoaded: false,
      blueprintName: '',
      blueprintNameToggleEdit: false,
      blueprintModalVisible: false
    }, _this.updateOrCreateBlueprint = function () {
      if (_this.props.onCreate) {
        var _this$state = _this.state,
            layerTemplates = _this$state.layerTemplates,
            blueprintName = _this$state.blueprintName;

        _this.props.onCreate({ layerTemplates: layerTemplates, blueprintName: blueprintName });
      }
    }, _this.saveCSV = function () {
      if (_this.props.onSaveCSV) {
        _this.props.onSaveCSV(_this.state.layerTemplates);
      }
    }, _this.onBlueprintModalSubmit = function (values) {
      var blueprint = _this.props.blueprint;

      _this.props.onBlueprintModalSubmit((0, _assign2.default)({}, values, {
        id: blueprint.id
      }));
    }, _this.addLayer = function () {
      var _this$state2 = _this.state,
          layerCount = _this$state2.layerCount,
          layerTemplates = _this$state2.layerTemplates;

      var updatedLayerCount = layerCount + 1;
      var updatedLayerTemplate = (0, _immutabilityHelper2.default)(layerTemplates, {
        $push: [{
          id: updatedLayerCount,
          title: 'Layer ' + updatedLayerCount,
          enableTitleEdit: false,
          contentType: null
        }]
      });
      _this.setState({
        layerTemplates: updatedLayerTemplate,
        layerCount: updatedLayerCount
      });
    }, _this.deleteLayer = function (id) {
      var layerTemplates = _this.state.layerTemplates;

      var splicedLayers = layerTemplates.filter(function (layer) {
        return layer.id !== id;
      });
      var updatedLayerTemplate = (0, _immutabilityHelper2.default)(layerTemplates, {
        $set: splicedLayers
      });
      _this.setState({
        layerTemplates: updatedLayerTemplate
      });
    }, _this.duplicateLayer = function (key) {
      var layerTemplates = [].concat((0, _toConsumableArray3.default)(_this.state.layerTemplates));
      var target = (0, _assign2.default)({}, layerTemplates.find(function (item) {
        return item.id === key;
      }));
      if (target) {
        target.id = (0, _generic.uuidv4)();
        layerTemplates.splice(layerTemplates.findIndex(function (item) {
          return item.id === key;
        }) + 1, 0, target);
        _this.setState({
          layerTemplates: layerTemplates,
          layerCount: _this.state.layerCount + 1
        });
      }
    }, _this.updateLayerFieldValue = function (id, key, value) {
      var isLastElement = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var layerTemplates = _this.state.layerTemplates;

      var layerIndex = layerTemplates.findIndex(function (layer) {
        return layer.id === id;
      });
      var updatedLayerTemplate = void 0;
      if (isLastElement) {
        updatedLayerTemplate = (0, _immutabilityHelper2.default)(layerTemplates, (0, _defineProperty3.default)({}, layerIndex, { $merge: {
            contentType: null,
            colours: [],
            media: []
          } }));
      } else {
        updatedLayerTemplate = (0, _immutabilityHelper2.default)(layerTemplates, (0, _defineProperty3.default)({}, layerIndex, { $merge: (0, _defineProperty3.default)({}, key, value) }));
      }
      _this.setState({
        layerTemplates: updatedLayerTemplate
      });
    }, _this.buildSelectInputBox = function (layer) {
      return _react2.default.createElement(
        _antd.Spin,
        { spinning: _this.props.layerSchema.length === 0 },
        _react2.default.createElement(_antd.Cascader, {
          className: 'layer-input-box',
          placeholder: 'Select Field Type',
          showSearch: {
            filter: function filter(inputValue, path) {
              return path.some(function (option) {
                return option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1;
              });
            },
            matchInputWidth: false
          },
          options: _this.props.layerSchema,
          onChange: function onChange(value) {
            return _this.updateLayerFieldValue(layer.id, 'contentType', value[1]);
          }
        })
      );
    }, _this.buildTitleEditor = function (layer) {
      var isDuplicate = _this.state.isDuplicate;

      var toggleTitleEdit = function toggleTitleEdit() {
        if (isDuplicate) {
          _this.updateLayerFieldValue(layer.id, 'enableTitleEdit', !layer.enableTitleEdit);
        }
      };

      if (layer.enableTitleEdit) {
        return _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_antd.Input, {
            value: layer.title,
            onChange: function onChange(e) {
              return _this.updateLayerFieldValue(layer.id, 'title', e.target.value);
            },
            onPressEnter: toggleTitleEdit,
            onBlur: toggleTitleEdit,
            suffix: _react2.default.createElement(_antd.Icon, { type: 'check', onClick: toggleTitleEdit })
          })
        );
      }

      return _react2.default.createElement(
        'div',
        { className: 'layer-title' },
        _react2.default.createElement(
          'span',
          { onClick: toggleTitleEdit },
          layer.title
        ),
        isDuplicate && _react2.default.createElement(
          'div',
          { className: 'layer-action-icons' },
          _react2.default.createElement(
            _antd.Tooltip,
            { title: 'Edit Name' },
            _react2.default.createElement(_antd.Icon, { onClick: toggleTitleEdit, type: 'edit' })
          ),
          _react2.default.createElement(
            _antd.Tooltip,
            { title: 'Duplicate Layer' },
            _react2.default.createElement(_antd.Icon, { onClick: function onClick() {
                return _this.duplicateLayer(layer.id);
              }, type: 'copy' })
          ),
          _react2.default.createElement(
            _antd.Popconfirm,
            {
              title: 'Delete Layer?',
              onConfirm: function onConfirm() {
                return _this.deleteLayer(layer.id);
              }
            },
            _react2.default.createElement(_antd.Icon, { type: 'delete' })
          )
        )
      );
    }, _this.buildContentType = function (layer) {
      var _this$props = _this.props,
          WSSEToken = _this$props.WSSEToken,
          mediaActionUrl = _this$props.mediaActionUrl;
      var isDuplicate = _this.state.isDuplicate;

      return _react2.default.createElement(_components.LayerInputFields, {
        layer: layer,
        WSSEToken: WSSEToken,
        mediaActionUrl: mediaActionUrl,
        onChange: function onChange(value, field, isLastElement) {
          return _this.updateLayerFieldValue(layer.id, field, value, isLastElement);
        },
        disableFields: !isDuplicate
      });
    }, _this.buildLayers = function () {
      var layerTemplates = _this.state.layerTemplates;

      return layerTemplates.map(function (layer) {
        return _react2.default.createElement(
          'div',
          { key: layer.id, className: 'dashed-layer-box' },
          _this.buildTitleEditor(layer),
          _react2.default.createElement(
            'div',
            { className: 'layer-content' },
            layer.contentType === null ? _this.buildSelectInputBox(layer) : _this.buildContentType(layer)
          )
        );
      });
    }, _this.buildBlueprintTitleInput = function () {
      var _this$state3 = _this.state,
          blueprintNameToggleEdit = _this$state3.blueprintNameToggleEdit,
          blueprintName = _this$state3.blueprintName;

      var toggleTitleEdit = function toggleTitleEdit() {
        if (blueprintName !== '') {
          _this.setState({ blueprintNameToggleEdit: !blueprintNameToggleEdit });
        }
      };
      if (blueprintNameToggleEdit) {
        return _react2.default.createElement(_antd.Input, {
          className: 'blueprint-title-input',
          value: blueprintName,
          onChange: function onChange(e) {
            return _this.setState({ blueprintName: e.target.value });
          },
          onPressEnter: toggleTitleEdit,
          onBlur: toggleTitleEdit,
          suffix: _react2.default.createElement(_antd.Icon, { type: 'check', onClick: toggleTitleEdit })
        });
      } else if (!blueprintName) return 'Unknown Blueprint';

      return _react2.default.createElement(
        'span',
        { className: 'blueprint-title-container' },
        _react2.default.createElement(
          'span',
          { onClick: toggleTitleEdit },
          blueprintName
        ),
        ' ',
        _react2.default.createElement(_antd.Icon, { onClick: _this.toggleModalVisible, type: 'setting' })
      );
    }, _this.saveButtonText = function () {
      var blueprint = _this.props.blueprint;
      var isDuplicate = _this.state.isDuplicate;

      if (isDuplicate) return 'Create New Blueprint';
      return blueprint && blueprint.layerTemplates && blueprint.layerTemplates.length !== 0 ? 'Update Blueprint' : 'Create Blueprint';
    }, _this.toggleModalVisible = function () {
      _this.setState(function (prevState) {
        return {
          blueprintModalVisible: !prevState.blueprintModalVisible
        };
      });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(LayerCreator, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var blueprint = nextProps.blueprint,
          savingCSV = nextProps.savingCSV,
          putBlueprintLoading = nextProps.putBlueprintLoading;


      if (this.props.savingCSV !== savingCSV) return;

      if (this.props.putBlueprintLoading && !putBlueprintLoading) {
        this.setState({
          blueprintModalVisible: false
        });
      }

      // need to add local state flag blueprintPreLoaded to keep track of whether the blueprint was already populated in to state. If yes, we don't want to write again,
      // ie for when error state occurs. Without it, all local changes to layer templates will be lost and reset to what props.blueprint was - JT
      if (blueprint && blueprint.layerTemplates && blueprint.layerTemplates.length !== 0 && !this.state.blueprintPreLoaded) {
        var layerTemplates = (0, _selectors.buildLayerCreatorLocalState)(nextProps.blueprint);
        this.setState({
          blueprintPreLoaded: true,
          layerTemplates: layerTemplates,
          layerCount: layerTemplates.length
        });
      }
      if (blueprint && blueprint.name) {
        this.setState({
          blueprintName: blueprint.name
        });
      }
      var isDuplicate = this.props.location.query.isDuplicate;

      this.setState({
        isDuplicate: isDuplicate === 'true' || blueprint && blueprint.layerTemplates && blueprint.layerTemplates.length === 0
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          blueprint = _props.blueprint,
          loading = _props.loading,
          putBlueprintLoading = _props.putBlueprintLoading,
          savingCSV = _props.savingCSV,
          WSSEToken = _props.WSSEToken,
          mediaActionURLForThumbnails = _props.mediaActionURLForThumbnails,
          mediaActionURLForGuides = _props.mediaActionURLForGuides,
          mediaActionURLForAeFiles = _props.mediaActionURLForAeFiles;
      var _state = this.state,
          blueprintModalVisible = _state.blueprintModalVisible,
          layerCount = _state.layerCount,
          isDuplicate = _state.isDuplicate;

      return _react2.default.createElement(
        'div',
        { className: 'LayerCreator__Component' },
        _react2.default.createElement(
          _components.Header,
          null,
          _react2.default.createElement(
            _reactRouter.Link,
            { to: '/creative_at_scale/create_blueprint' },
            _react2.default.createElement(_antd.Icon, { type: 'rollback' })
          ),
          this.buildBlueprintTitleInput(),
          _react2.default.createElement(
            _antd.Button,
            { loading: loading, className: 'float-right', onClick: this.updateOrCreateBlueprint, type: 'primary' },
            this.saveButtonText()
          ),
          _react2.default.createElement(
            _antd.Button,
            { loading: savingCSV, style: { marginRight: 10 }, className: 'float-right', onClick: this.saveCSV },
            'Save JSON Feed'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'content' },
          _react2.default.createElement(
            _antd.Row,
            { style: { width: (layerCount + (isDuplicate ? 1 : 0)) * 330 + 'px' } },
            _react2.default.createElement(
              _antd.Spin,
              { spinning: loading },
              this.buildLayers(),
              isDuplicate && _react2.default.createElement(
                _antd.Button,
                { type: 'dashed', onClick: this.addLayer, className: 'add-layer-button' },
                _react2.default.createElement(_antd.Icon, { type: 'plus' }),
                ' Add Layer'
              )
            )
          ),
          _react2.default.createElement(_components.BlueprintModal, {
            blueprint: (0, _selectors.buildBlueprintLocalState)(blueprint),
            visible: blueprintModalVisible,
            loading: putBlueprintLoading,
            onCancel: this.toggleModalVisible,
            onSubmit: this.onBlueprintModalSubmit,
            WSSEToken: WSSEToken,
            mediaActionURLForThumbnails: mediaActionURLForThumbnails,
            mediaActionURLForGuides: mediaActionURLForGuides,
            mediaActionURLForAeFiles: mediaActionURLForAeFiles
          })
        )
      );
    }
  }]);
  return LayerCreator;
}(_react.Component), _class.propTypes = {
  onCreate: _propTypes2.default.func.isRequired,
  onSaveCSV: _propTypes2.default.func.isRequired,
  onBlueprintModalSubmit: _propTypes2.default.func.isRequired,
  loading: _propTypes2.default.bool.isRequired,
  putBlueprintLoading: _propTypes2.default.bool.isRequired,
  savingCSV: _propTypes2.default.bool.isRequired,
  blueprint: _propTypes2.default.shape({
    name: _propTypes2.default.string.isRequired
  }),
  layerSchema: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
  mediaActionUrl: _propTypes2.default.string,
  WSSEToken: _propTypes2.default.string,
  location: _propTypes2.default.shape({
    query: _propTypes2.default.shape({
      isDuplicate: _propTypes2.default.string
    })
  }).isRequired,
  mediaActionURLForThumbnails: _propTypes2.default.string.isRequired,
  mediaActionURLForGuides: _propTypes2.default.string.isRequired,
  mediaActionURLForAeFiles: _propTypes2.default.string.isRequired
}, _class.defaultProps = {
  blueprint: null,
  mediaActionUrl: '',
  WSSEToken: '',
  mediaActionURLForThumbnails: '',
  mediaActionURLForGuides: '',
  mediaActionURLForAeFiles: ''
}, _temp2);
exports.default = LayerCreator;


//////////////////
// WEBPACK FOOTER
// ./~/@adparlor-devops/ms-paint/lib/modules/LayerCreator/components/LayerCreator.js
// module id = 3934
// module chunks = 8